import request from '../libs/request';

const res = 'PlanJob';

export default {
  execute(id) {
    return request({
      url: `api/${res}/execute`,
      method: 'post',
      data: {
        id
      }
    });
  }
};
